import STTypo from '../typo/STTypo';
import { IntlMessages } from '../../helpers';
import { TextCell } from '..';
import React from 'react';

export const Column = ({ color, IdIntl, key, keyName, ...props }) => {
  return {
    title: (
      <STTypo color={color}>
        <IntlMessages id={IdIntl} />
      </STTypo>
    ),
    key: key,
    sorter: (a, b) => ('' + a[keyName]).localeCompare(b[keyName]),
    render: object => TextCell(object[keyName]),
    ...props
  };
};
